<script setup lang="ts">
defineProps<{ open: boolean }>();
const emit = defineEmits<{ (e: 'confirm'): void; (e: 'cancel'): void }>();
</script>

<template>
  <div v-if="open" class="ccm__overlay" @click.self="emit('cancel')">
    <div class="ccm__modal">
      <i class="pi pi-exclamation-triangle ccm__icon" />
      <h3 class="ccm__title">Contraste insuffisant</h3>
      <p class="ccm__desc">
        Certains textes ne respectent pas le contraste minimum recommandé et
        pourraient être difficiles à lire. Voulez-vous vraiment enregistrer
        malgré cet avertissement ?
      </p>
      <div class="ccm__actions">
        <button class="ccm__btn ccm__btn--ghost" @click="emit('cancel')">
          Annuler
        </button>
        <button class="ccm__btn ccm__btn--primary" @click="emit('confirm')">
          Enregistrer quand même
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.ccm__overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
}
.ccm__modal {
  background: var(--nxt-surface, #fff);
  border-radius: 0.875rem;
  padding: 1.5rem;
  max-width: 26rem;
  width: calc(100% - 2rem);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
}
.ccm__icon {
  color: #f59e0b;
  font-size: 1.5rem;
}
.ccm__title {
  margin: 0.5rem 0 0.5rem;
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--nxt-on-surface, #111);
}
.ccm__desc {
  margin: 0 0 1.25rem;
  font-size: 0.875rem;
  color: var(--nxt-on-surface-variant, #555);
  line-height: 1.5;
}
.ccm__actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.625rem;
}
.ccm__btn {
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  font-size: 0.8125rem;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid transparent;
}
.ccm__btn--ghost {
  background: transparent;
  color: var(--nxt-on-surface-variant, #555);
  border-color: var(--nxt-outline-variant, #e0e0e0);
}
.ccm__btn--ghost:hover {
  background: var(--nxt-surface-low, #f5f5f5);
}
.ccm__btn--primary {
  background: #f59e0b;
  color: #fff;
}
.ccm__btn--primary:hover {
  opacity: 0.9;
}
</style>
